import React, { Component } from "react";
import "../resources/posts.css";
import Logo from "./commons/Logo";
import ExploreOutlinedIcon from "@mui/icons-material/ExploreOutlined";
import StarBorderOutlinedIcon from "@mui/icons-material/StarBorderOutlined";
import Explore from "./postsSections/Explore";
import PermIdentityOutlinedIcon from "@mui/icons-material/PermIdentityOutlined";
import { Switch, Route, Redirect } from "react-router-dom";
import { NavLink } from "react-router-dom";
import NotFound from "./NotFound";
import Profile from "./postsSections/profile/Profile";
import userService from "../services/userService";
import PostAndReplies from "./postsSections/PostAndReplies";
import SearchWidget from "./commons/SearchWidget";
import Search from "./Search";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import Bookmarks from "./postsSections/Bookmarks";
import ExploreIcon from "@mui/icons-material/Explore";
import PersonIcon from "@mui/icons-material/Person";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import SearchIcon from "@mui/icons-material/Search";
import Trending from "./postsSections/Trending";

import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import AdminDashboard from "./postsSections/AdminDashboard";
import Settings from "./postsSections/settings/Settings";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import SettingsIcon from "@mui/icons-material/Settings";
import Contact from "./postsSections/Contact";
import { Button } from "@mui/material";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import SimpleBar from "simplebar-react";

class Posts extends Component {
  state = {
    currentSection: "explore",
    explore: {
      currentCategory: "",
      load: false,
    },
    showContactModal: false,
  };

  setSelectedSection = (name) => {
    this.setState({
      currentSection: name,
    });
  };

  componentDidMount() {
    document.body.style.overflowY = "scroll";
  }

  componentWillUnmount() {
    document.body.style.overflowY = null;
  }

  handleExploreCategoryChange = (category) => {
    const explore = { ...this.state.explore };
    explore.currentCategory = category;
    explore.load = true;
    this.setState({
      explore,
    });
  };

  render() {
    const user = userService.getCurrentUser();
    const { explore, showContactModal } = this.state;
    return (
      <>
        <div className="posts-sections">
          <div className="post-section" id="left-nav">
            <Logo />
            <NavLink to="/explore" className="nav-item">
              <Route
                path="/explore"
                children={({ match }) =>
                  match ? (
                    <ExploreIcon className="icon" />
                  ) : (
                    <ExploreOutlinedIcon className="icon" />
                  )
                }
              />
              <div className="nav-item-label">Explore</div>
            </NavLink>
            <NavLink
              to={`/profile/${user.sub}`}
              className="nav-item"
              isActive={(match, location) =>
                location.pathname.startsWith("/profile")
              }
            >
              <Route
                path="/profile"
                children={({ match }) =>
                  match ? (
                    <PersonIcon className="icon" />
                  ) : (
                    <PersonOutlinedIcon className="icon" />
                  )
                }
              />
              <div className="nav-item-label">Profile</div>
            </NavLink>
            <NavLink to="/bookmarks" className="nav-item">
              <Route
                path="/bookmarks"
                children={({ match }) =>
                  match ? (
                    <BookmarkIcon className="icon" />
                  ) : (
                    <BookmarkBorderIcon className="icon" />
                  )
                }
              />
              <div className="nav-item-label">Bookmarks</div>
            </NavLink>
            <NavLink to="/settings" className="nav-item">
              <Route
                path="/settings"
                children={({ match }) =>
                  match ? (
                    <SettingsIcon className="icon" />
                  ) : (
                    <SettingsOutlinedIcon className="icon" />
                  )
                }
              />
              <div className="nav-item-label">Settings</div>
            </NavLink>
            <NavLink to="/search" className="nav-item" id="search-navitem">
              <SearchIcon className="icon" />
              <div className="nav-item-label">Search</div>
            </NavLink>
            {user.isAdmin && (
              <NavLink to="/admin" className="nav-item">
                <Route
                  path="/admin"
                  children={({ match }) =>
                    match ? (
                      <AdminPanelSettingsIcon className="icon" />
                    ) : (
                      <AdminPanelSettingsOutlinedIcon className="icon" />
                    )
                  }
                />
                <div className="nav-item-label">Admin</div>
              </NavLink>
            )}
          </div>
          <div className="post-section" id="content-nav">
            <Switch>
              <Route
                path="/explore/:category?"
                exact
                render={(props) => (
                  <Explore
                    {...props}
                    onCategoryChange={this.handleExploreCategoryChange}
                  />
                )}
              />
              <Route path="/bookmarks" exact component={Bookmarks} />
              <Route
                path="/profile/:name"
                render={(props) => {
                  return <Profile {...props} key={props.match.params.name} />;
                }}
              />
              <Route path="/post/:id" exact component={PostAndReplies} />
              <Route path="/search" exact component={Search} />
              <Route path="/admin" exact component={AdminDashboard} />
              <Route path="/settings" component={Settings} />
              <Redirect from="/" exact to="/explore" />
              <Route component={NotFound} />
            </Switch>
          </div>
          <div className="post-section" id="right-nav">
            <SimpleBar
              style={{
                height: "100%",
                padding: "10px 20px",
                boxSizing: 'border-box'
              }}
            >
              <div
                style={{
                  paddingTop: 10,
                  paddingBottom: 20,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  boxSizing: "border-box",
                }}
              >
                <div>
                  <h3 style={{ marginTop: 0, marginBottom: 10, color: "grey" }}>
                    Search
                  </h3>
                  <SearchWidget />
                  {explore.load && (
                    <Trending
                      category={explore.currentCategory}
                      key={JSON.stringify(explore.currentCategory)}
                    />
                  )}
                </div>
                <div
                  style={{
                    marginTop: 20,
                  }}
                >
                  <hr
                    style={{
                      opacity: 0.5,
                    }}
                  />
                  <div
                    className="legal-notice"
                    style={{
                      marginTop: 10,
                      fontSize: 13,
                      color: "grey",
                    }}
                  >
                    <div>
                      <a
                        href="/tos"
                        target="_blank"
                        style={{
                          marginRight: 5,
                        }}
                      >
                        Terms of Use
                      </a>
                      ·
                      <a
                        href="/privacy"
                        target="_blank"
                        style={{
                          marginLeft: 5,
                          marginRight: 5
                        }}
                      >
                        Privacy Policy
                      </a>
                      ·
                      <a
                        style={{
                          marginLeft: 5,
                          cursor: 'pointer'
                        }}
                        onClick={() =>
                          this.setState({
                            showContactModal: true,
                          })
                        }
                      >
                        Contact Us
                      </a>
                    </div>
                    © 2022 OuMedia.
                  </div>
                </div>
              </div>
            </SimpleBar>
          </div>
        </div>
        <Contact
          open={showContactModal}
          onClose={() =>
            this.setState({
              showContactModal: false,
            })
          }
        />
      </>
    );
  }
}

export default Posts;
